// 分片大小
export const MIN_PART_SIZE = 1024 * 1024 * 5;

// 上传并发数
export const PARALLEL = 4;

export const AK = 'AKIA2CUNLDY4MHOADT7D';
export const SK = 'EA7T7XWdrW6HY3POFvx55PGy1D0h+c8tU8BuHvMa';
export const REGION = 'ap-southeast-2';
export const BUCKET = 'mouxu-test-2';
